import { computed } from 'vue'

import { FunnelStepId } from '@/funnelStepId'
import {useHelpers} from "@/useHelpers"

export function useFunnelSteps(steps) {
    const { sendMessage } = useHelpers()
    const getStep = (stepId) => steps.find((step) => step.id === stepId)

    const selectStep = (stepId) =>  {
        steps.map((item) => item.isActive = false)
        const step = getStep(stepId)
        if (step) {
            step.isActive = true
            sendMessage('stepSelected', {stepId})
        }
    }

    const completeStep = (stepId) => {
        const step = getStep(stepId)
        if (step) {
            step.isCompleted = true
            sendMessage('stepCompleted', {stepId})
        }
    }
    const invalidateStep = (stepId) => {
        const step = getStep(stepId)
        if (step) {
            step.isCompleted = false
        }
    }

    const getNextUncompletedStep = () => steps.find((item) => !item.isCompleted && !item.isHidden)?.id

    const handleCompeteStep = (actualStepId) => {
        completeStep(actualStepId)
        const uncompletedStepId = getNextUncompletedStep()
        selectStep(uncompletedStepId)
    }

    const handleChangeStep = (stepId) => {
        invalidateStep(stepId)
        selectStep(stepId)
    }

    /**
     * Assigns sequential order to visible steps.
     * Steps that are hidden will have their order set to null.
     */
    const assignStepsOrder = (steps) => {
        let order = 1
        steps.forEach(step => {
            step.order = step.isHidden ? null : order++
        })
    }

    return {
        steps,
        completeStep,
        invalidateStep,
        getNextUncompletedStep,
        handleCompeteStep,
        handleChangeStep,
        assignStepsOrder,
        subscriptionStep: computed(() => getStep(FunnelStepId.SUBSCRIPTION)),
        subscriptionAmountStep: computed(() => getStep(FunnelStepId.SUBSCRIPTION_AMOUNT)),
        accountStep: computed(() => getStep(FunnelStepId.ACCOUNT)),
        paymentFrequencyStep: computed(() => getStep(FunnelStepId.PAYMENT_FREQUENCY)),
        deliveryMethodStep: computed(() => getStep(FunnelStepId.DELIVERY_METHOD)),
        giftedInfoStep: computed(() => getStep(FunnelStepId.GIFTED_INFO)),
        studentInfoStep: computed(() => getStep(FunnelStepId.STUDENT_INFO)),
        addressStep: computed(() => getStep(FunnelStepId.ADDRESS)),
        paymentMethodStep: computed(() => getStep(FunnelStepId.PAYMENT_METHOD)),
        summaryStep: computed(() => getStep(FunnelStepId.SUMMARY)),
    }
}